export const colors = [
    { name: 'Hotpink', hex: "#F50D5A" },
    { name: 'Orange', hex: "#FF865C" },
    { name: 'Yellow', hex: "#FFEA5C" },
    { name: 'Green', hex: "#00DA76" },
    { name: 'Blue', hex: "#0096CE" },
    { name: 'Violet', hex: "#800FFF" }
];